import React from "react";
import { useEffect, useState, useRef } from "react";
import AtkLoader from "../../../AtlaskitControls/AtkLoader";
import { InputTextarea } from "primereact/inputtextarea";

export default function CompanyOverview(props: any) {
  const [isOverviewEditing, setIsOverviewEditing] = useState(false);
  const [isAboutUsEditing, setIsAboutUsEditing] = useState(false);
  const [isVisionEditing, setIsVisionEditing] = useState(false);
  const [isMissionEditing, setIsMissionEditing] = useState(false);
  return (
    <div className="container p-0  border" >
      <section className="section-agency">
        <div className="row  px-3 ">
          <div className="col-12 ">
            <span className="h3 pt-2" style={{ borderTop: `2px solid ${props.secondaryColor}`, color: props.primaryColor }}>
              Company Overview{" "}
              {props.isEditable && !props.isGeneratingPdf ?
                <>
                  {!isOverviewEditing ? (
                    <i className="fa fa-pencil text-12 ms-2 show-cursor" title="Edit" onClick={() => setIsOverviewEditing(true)} />
                  ) : (
                    <span className="text-12 ">
                      {isOverviewEditing && props.saveLoading ? (
                        <div className="d-inline-flex align-items-center">
                          <AtkLoader />
                        </div>
                      ) : (
                        <i
                          className="fa fa-check mx-2 show-cursor text-success"
                          title="Save"
                          onClick={() => {
                            setIsOverviewEditing(false);
                            props.onTemplateDetailsSave();
                          }}
                        />
                      )}
                      <i
                        className="fa fa-times show-cursor text-danger"
                        title="Cancel"
                        onClick={() => {
                          setIsOverviewEditing(false);
                          props.onCancelTemplateDetailsToSave();
                        }}
                      />
                    </span>
                  )}
                </>
                :
                null}
            </span>
            {isOverviewEditing ? (
              <InputTextarea value={props.companyOverview} onChange={props.onCompanyOverviewChange} autoResize className="text-12 w-100 mb-3" />
            ) : (
              <p className="mt-2 text-12">{props.companyOverview}</p>
            )}

            <span className="h5 pt-2">
              About Us{" "}
              {props.isEditable && !props.isGeneratingPdf ?
                <>
                  {!isAboutUsEditing ? (
                    <i className="fa fa-pencil text-12 ms-2 show-cursor" title="Edit" onClick={() => setIsAboutUsEditing(true)} />
                  ) : (
                    <span className="text-12 ">
                      {isAboutUsEditing && props.saveLoading ? (
                        <div className="d-inline-flex align-items-center">
                          <AtkLoader />
                        </div>
                      ) : (
                        <i
                          className="fa fa-check mx-2 show-cursor text-success"
                          title="Save"
                          onClick={() => {
                            setIsAboutUsEditing(false);
                            props.onTemplateDetailsSave();
                          }}
                        />
                      )}
                      <i
                        className="fa fa-times show-cursor text-danger"
                        title="Cancel"
                        onClick={() => {
                          setIsAboutUsEditing(false);
                          props.onCancelTemplateDetailsToSave();
                        }}
                      />
                    </span>
                  )}
                </>
                :
                null}
            </span>
            <span className="mt-2 text-12 ">
              {isAboutUsEditing ? (
                <InputTextarea value={props.aboutUs} onChange={props.onAboutUsChange} autoResize className="w-100 " />
              ) : (
                <p className="mt-2" >
                  {props.aboutUs}
                </p>
              )}
            </span>

            <span className="h5 pt-2">
              Vision{" "}
              {props.isEditable && !props.isGeneratingPdf ?
                <>
                  {!isVisionEditing ? (
                    <i className="fa fa-pencil text-12 ms-2 show-cursor" title="Edit" onClick={() => setIsVisionEditing(true)} />
                  ) : (
                    <span className="text-12 ">
                      {isVisionEditing && props.saveLoading ? (
                        <div className="d-inline-flex align-items-center">
                          <AtkLoader />
                        </div>
                      ) : (
                        <i
                          className="fa fa-check mx-2 show-cursor text-success"
                          title="Save"
                          onClick={() => {
                            setIsVisionEditing(false);
                            props.onTemplateDetailsSave();
                          }}
                        />
                      )}
                      <i
                        className="fa fa-times show-cursor text-danger"
                        title="Cancel"
                        onClick={() => {
                          setIsVisionEditing(false);
                          props.onCancelTemplateDetailsToSave();
                        }}
                      />
                    </span>
                  )}
                </>
                :
                null}
            </span>
            <span className="mt-2 text-12">
              {isVisionEditing ? (
                <InputTextarea value={props.vision} onChange={props.onVisionChange} autoResize className="w-100" />
              ) : (
                <p className="mt-2 " >
                  {props.vision}
                </p>
              )}
            </span>
            <span className="h5 pt-2">
              Mission
              {props.isEditable && !props.isGeneratingPdf ?
                <>
                  {!isMissionEditing ? (
                    <i className="fa fa-pencil text-12 ms-2 show-cursor" title="Edit" onClick={() => setIsMissionEditing(true)} />
                  ) : (
                    <span className="text-12 ">
                      {isMissionEditing && props.saveLoading ? (
                        <div className="d-inline-flex align-items-center">
                          <AtkLoader />
                        </div>
                      ) : (
                        <i
                          className="fa fa-check mx-2 show-cursor text-success"
                          title="Save"
                          onClick={() => {
                            setIsMissionEditing(false);
                            props.onTemplateDetailsSave();
                          }}
                        />
                      )}
                      <i
                        className="fa fa-times show-cursor text-danger"
                        title="Cancel"
                        onClick={() => {
                          setIsMissionEditing(false);
                          props.onCancelTemplateDetailsToSave();
                        }}
                      />
                    </span>
                  )}
                </>
                :
                null}
            </span>
            <span className=" text-12">
              {isMissionEditing ? (
                <InputTextarea value={props.mission} onChange={props.onMissionChange} autoResize className="w-100" />
              ) : (
                <p className="mt-2 text-12" >
                  {props.mission}
                </p>
              )}
            </span>
          </div>
          {props.teamMembers != "" && props.teamMembers != null ? (
             <span className="h3 pt-2" style={{color: props.primaryColor }}>
              Team Members{" "}</span>
          ) : null}

          {props.teamMembers.map((member: any, index: number) => (
            <div className="col-lg-3 col-md-4 col-sm-12 col-12  text-center mt-2 mb-5">
              <div key={index} className="card rounded-0" style={{minHeight:"200px" }}>
             <div
               className="mb-3 mt-4 fw-bold mx-auto bg-light rounded-circle fs-3 d-flex justify-content-center align-items-center"
                 style={{
                       color: `${props.secondaryColor}`,
                      //  padding: "10px 15px",
                       width: "60px",
                       height: "60px",
                       overflow: "hidden",
                       }}
                      >
                   {member.profilePhoto ? (
                     <img
                        src={member.profilePhoto}
                        alt={member.name}
                       style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                            }}
                         />
                     ) : member.name ? (
                         member.name
                              .split(" ")
                              .map((word: any) => word[0])
                              .slice(0, 2)
                              .join("")
                        ) : (
                         "New"
                     )}
                </div>

                <div className="text-dark mb-3">
                  <h6 className="mb-1">{member.name}</h6>
                  <p className="text-12 ">{member.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
